import styled from "styled-components";

export const RightImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 25% 25%;
`;
